import type { TermsOfService } from "./compliance-types";

/** Shown when the API could not resolve the document's type (no name, no key). */
export const UNRESOLVED_DOCUMENT_TYPE = "—";

/** The document type to show for a ToS document: name, else key, else a dash. */
export function documentTypeLabel(
  doc: Partial<Pick<TermsOfService, "documentTypeName" | "documentTypeKey">>,
): string {
  return doc.documentTypeName ?? doc.documentTypeKey ?? UNRESOLVED_DOCUMENT_TYPE;
}
